import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserDistanceDimension } from '@paragon/contract-library';
import { allComponentDesignsUnloaded, componentDesignsDeletedWithInsertions } from '@paragon/layout-models';

import { setDimensionMode } from './applicationSlice';
import { __UNSAFE_designItemsSelected } from './selectionsSlice';

export function getUserDistanceDimensionHash(userDistanceDimension: UserDistanceDimension) {
  return `(${userDistanceDimension.start.x},${userDistanceDimension.start.y})-(${userDistanceDimension.end.x},${userDistanceDimension.end.y})`;
}

export type LocalUserDimensionsState = readonly UserDistanceDimension[];

const initialState: LocalUserDimensionsState = [];

const localUserDimensionsSlice = createSlice({
  name: 'localUserDimensions',
  initialState,
  reducers: {
    addLocalUserDistanceDimension: (state, action: PayloadAction<UserDistanceDimension>) => {
      if (
        state.some(
          (userDistanceDimension) =>
            getUserDistanceDimensionHash(userDistanceDimension) === getUserDistanceDimensionHash(action.payload),
        )
      )
        return;
      state.push(action.payload);
    },
    deleteNewestLocalUserDimension: (state) => void state.pop(),
    clearLocalUserDistanceDimensions: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(__UNSAFE_designItemsSelected, (state, action) => {
      if (action.payload.changingComponentDesign) {
        state.splice(0, state.length);
      }
    });
    builder.addCase(setDimensionMode, (state, action) => {
      const dimensionModeOn = action.payload;
      if (!dimensionModeOn) return initialState;
      return state;
    });

    builder.addCase(componentDesignsDeletedWithInsertions, () => initialState);

    builder.addCase(allComponentDesignsUnloaded, () => initialState);
  },
});

export const { addLocalUserDistanceDimension, deleteNewestLocalUserDimension, clearLocalUserDistanceDimensions } =
  localUserDimensionsSlice.actions;
export const localUserDimensions = localUserDimensionsSlice.reducer;
